// src/components/UserRankBadge.jsx
import React from 'react';

// 1. Import your images (assuming they are in src/assets/emblems)
import BronzeEmblem from '../../assets/emblems/Bronze.png';
import SilverEmblem from '../../assets/emblems/Silver.png';
import GoldEmblem from '../../assets/emblems/Gold.png';
import IronEmblem from '../../assets/emblems/Iron.png';
import EmeraldEmblem from '../../assets/emblems/Emerald.png';
import PlatinumEmblem from '../../assets/emblems/Platinum.png';
import DiamondEmblem from '../../assets/emblems/Diamond.png';
import '../../Style/rankBadge.css';

// 2. Create the Map
const RANK_IMAGES = {
  BRONZE: BronzeEmblem,
  SILVER: SilverEmblem,
  GOLD: GoldEmblem,
  IRON: IronEmblem,
  EMERALD: EmeraldEmblem,
  PLATINUM: PlatinumEmblem,
  DIAMOND: DiamondEmblem,
};

function UserRankBadge({ rank, customStyle, className }) {
  const defaultStyle = {
    width: '160px',
    height: '130px',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto',
  };
  // 1. Clean the string: remove spaces and make it uppercase
  const lookupRank = rank ? rank.trim().toUpperCase() : '';

  // 2. Look it up in your object
  const emblemSrc = RANK_IMAGES[lookupRank];

  return (
    <div className={`rank-badge-container ${className || ''}`}>
      {emblemSrc ? (
        <img
          src={emblemSrc}
          alt={`${rank} rank emblem`}
          className="rank-emblem-img"
          style={customStyle || defaultStyle}
        />
      ) : (
        <div style={{ fontSize: '3rem' }}>🏆</div>
      )}
    </div>
  );
}

export default UserRankBadge;
